module.exports = __webpack_public_path__ + "static/img/foreign.0259741f.png";